import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import EditIcon from '@mui/icons-material/Edit'
import PvInstallationIcon from '@mui/icons-material/SolarPower'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { EditProps } from '../shared/EditProps'
import { useAuth } from '../../context/useAuth'
import Typography from '@mui/material/Typography'

export default function EditPvInstallation({ disabled, schema, value, setData }: EditProps) {
  const { name } = useParams()
  const { csrf, simulation } = useAuth()
  const [error, setError] = React.useState<any>(undefined)
  const [open, setOpen] = React.useState(false)

  const pvinstallationInputData = simulation?.simulation_input_data?.pv_production_simulation?.data_file

  const checkPVInputData = () => {
		if (pvinstallationInputData) return true
		return false
	}

  const generateFilteredSchema = (condition: boolean) => {
    if (condition && schema.properties) {
      // Return a filtered schema with only specific fields
      return {
        type: 'object',
        properties: {
          name: schema.properties.name,
          P_STC: schema.properties.P_STC,
          n_panels: schema.properties.n_panels,
        },
      };
    } else {
      // Return the full schema
      return schema;
    }
  };

  const schemaToUse = generateFilteredSchema(checkPVInputData());

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Edit PV Installation`}
      icon={<PvInstallationIcon />}
      iconButton={<EditIcon />}
      content={
        <>
				<Typography variant='caption' color='error' sx={{ mx: 2, mt: -1 }}>
				{error || ''}
				</Typography>
        <Form
          onSubmit={async (e) => {
            try {
              // Filter form data based on properties in the filtered schema
              const filteredFormData: { [key: string]: any } = {};
              Object.keys(e.formData).forEach((key) => {
                if (schemaToUse.properties && (schemaToUse.properties as { [key: string]: JSONSchema7 })[key]) {
                  filteredFormData[key] = e.formData[key];
                }
              });

              const res = await axios.put(
                `${process.env.REACT_APP_API}/${name}/pvinstallation/${value.name}`,
                JSON.stringify(filteredFormData),
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrf,
                  },
                  withCredentials: true,
                }
              )
              setData(res.data)
              setOpen(false)
            } catch (err: any) {
              console.log('err:', err)
              if (err?.response?.data?.error) {
                setError(err.response.data.error);
              } else {
                setError("An unknown error occurred."); // Handle unknown errors
              } 
            }
          }}
          validator={validator}
          schema={schemaToUse as JSONSchema7}
          formData={value}
        />
        </>
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
